export default "__VITE_ASSET__fa933ac7__"